(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hv-header"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',function(event){const link=event.target.closest('.hv-menu a');if(link)link.closest('details').removeAttribute('open')});document.addEventListener('keydown',function(event){if(event.key==='Escape')document.querySelectorAll('.hv-menu[open]').forEach(menu=>menu.removeAttribute('open'))});

  } catch(e) { console.error(e); }
})();
})();
